import React from 'react'
import IdeaCard from '../IdeaCard'
import { CategoryColumn as CategoryColumnType } from '../types'
import {
	AddIdeaButton,
	IdeaCount,
	ColumnContainer,
	ColumnContent,
	ColumnHeader,
	ColumnTitle,
	EmptyState,
	CardsWrapper,
} from './CategoryColumn.styles'

interface CategoryColumnProps {
	column: CategoryColumnType
	onAddIdea: (category: string) => void
	onEditIdea: (ideaId: string) => void
}

const CategoryColumn: React.FC<CategoryColumnProps> = ({
	column,
	onAddIdea,
	onEditIdea,
}) => {
	return (
		<ColumnContainer>
			<ColumnHeader>
				<ColumnTitle>{column.displayName}</ColumnTitle>
				<IdeaCount>{column.ideas.length}</IdeaCount>
			</ColumnHeader>

			<ColumnContent>
				<CardsWrapper>
					{column.ideas.map(idea => (
						<IdeaCard
							key={idea.id}
							idea={idea}
							onEdit={onEditIdea}
						/>
					))}

					{column.ideas.length === 0 && (
						<EmptyState>
							No ideas yet
							<br />
							Click "Add Idea" to get started
						</EmptyState>
					)}
				</CardsWrapper>

				<AddIdeaButton onClick={() => onAddIdea(column.category)}>
					+ Add Idea
				</AddIdeaButton>
			</ColumnContent>
		</ColumnContainer>
	)
}

export default CategoryColumn
